import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Icon, Table, Card, Popup, Dropdown, Loader} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {pageSizes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import TablePaginator from '../../../common/components/tablePaginator';

class SetsSalesTable extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  onPageClick(value) {
    this.props.changeSetSalesListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeSetsalesListPageSize(data.value);
  }

  renderLoad() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    return this.renderSetSales();
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  renderSetSales() {
    const {setSalesList, startDateFilter, endDateFilter} = this.props;

    if (!setSalesList.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%' textAlign='center'>No se encuentran datos disponibles</Table.Cell>
        </Table.Row>
      );
    }

    return setSalesList.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.customerId}</Table.Cell>
          <Table.Cell textAlign='center'>{element.customerName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.setCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.total}</Table.Cell>
          <Table.Cell textAlign='center'>
            {'$'}
            {getNumericValue(element.totalDetail, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <Popup
              trigger={
                <Link
                  to={
                    `/venta-combo-detalle/${startDateFilter}/${endDateFilter}` +
                    `/${element.customerId}/${element.setCode}`
                  }
                >
                  <Icon name='eye' color='blue' size='large' />
                </Link>
              }
              content='Detalle'
              position='top center'
              inverted
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    return (
      <Card fluid raised>
        <Table striped className='toyota-grid'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Ruc</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Clente</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Código Combo
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Valor Total
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Acción</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.renderLoad()}
          </Table.Body>
          {this.renderPagination()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'setSalesList': state.setsHeadSales.filteredList,
    'totalItems': state.setsHeadSales.list.length,
    'pageNumber': state.setsHeadSales.pageNumber,
    'pageSize': state.setsHeadSales.pageSize,
    'loading': state.setsHeadSales.loading,
  };
};

const {
  changeSetSalesListPage,
  changeSetsalesListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  changeSetSalesListPage,
  changeSetsalesListPageSize,
})(SetsSalesTable);
